import { supabase } from "@/integrations/supabase/client";
import { handleSupabaseFunctionError } from "@/utils/supabaseFunctionsError";
import type {
  GetTargetareMatriceResponse,
  RunTargetareJobResponse,
} from "@/api/types/targetareMatrice";

function assertSuccess(data: unknown, endpoint: string): void {
  if (
    !data ||
    typeof data !== "object" ||
    (data as { success?: unknown }).success !== true
  ) {
    throw new Error(`Răspuns invalid de la ${endpoint}`);
  }
}

export async function getTargetareMatrice(): Promise<GetTargetareMatriceResponse> {
  const { data, error } = await supabase.functions.invoke(
    "api/targetare/matrice",
    { method: "GET" }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/matrice");
  return data;
}

export async function runTargetareMatrice(): Promise<RunTargetareJobResponse> {
  const { data, error } = await supabase.functions.invoke(
    "api/targetare/matrice",
    { method: "POST", body: {} }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/matrice");
  return data;
}

export async function runTargetareSurse(): Promise<RunTargetareJobResponse> {
  const { data, error } = await supabase.functions.invoke(
    "api/targetare/surse",
    { method: "POST", body: {} }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/surse");
  return data;
}
